import { useAdvancedForm } from 'helpers/form/useAdvancedForm';
import React, { useCallback, useMemo } from 'react';
import { Field } from 'components/uikit/Field';
import { HookFormDropDownInput } from 'components/uikit/inputs/dropdown/HookFormDropDownInput';
import { HookFormMultiSelectDropDownInput } from 'components/uikit/inputs/dropdown/HookFormMultiSelectDropDownInput';
import {
  Button,
  ButtonColor,
  ButtonWidth,
} from 'components/uikit/buttons/Button';
import { ProjectCard } from 'pages/authorized/projects/components/projectCard/ProjectCard';
import { HookFormDatePicker } from 'components/uikit/inputs/date-time/HookFormDatePicker';
import { Input } from 'components/uikit/inputs/Input';
import { HookFormTimePicker } from 'components/uikit/inputs/date-time/HookFormTimePicker';
import { requiredRule } from 'helpers/form/react-hook-form-helper';
import { Links } from 'application/constants/links';
import { AppLink } from 'components/uikit/buttons/AppLink';
import { useScopedTranslation } from 'application/localization/useScopedTranslation';
import DeleteIcon from 'assets/icons/delete.svg?react';
import LogoutIcon from 'assets/icons/exit.svg?react';

import styles from './UiKitPage.module.scss';
import { FabButton } from 'components/uikit/buttons/FabButton';
import {
  TextButton,
  TextButtonColor,
} from 'components/uikit/buttons/TextButton';
import { useModal } from '../../../components/uikit/modal/useModal';

enum ProductType {
  Undefined,
  Auto,
  Electronic,
  Other,
}

type UiKitForm = {
  dropDown: ProductType;
  multiSelectDropDown: ProductType[];
  timeInMilliseconds: number;
  date: Date;
  input: string;
};

export const UiKitPage: React.FC = () => {
  const i18n = useScopedTranslation('Page.uikit');
  const form = useAdvancedForm<UiKitForm>(
    useCallback(async (data) => {
      console.log(data);
      alert(JSON.stringify(data));
    }, []),
  );
  const options = useMemo(() => {
    return [ProductType.Auto, ProductType.Electronic, ProductType.Other];
  }, []);

  const personOption = useMemo(() => {
    return ['Adrian Motavas', 'Anke Venema'];
  }, []);
  const modals = useModal();
  return (
    <div>
      <AppLink
        color={ButtonColor.Primary}
        to={Links.Authorized.Projects.link()}
      >
        Back
      </AppLink>
      <form onSubmit={form.handleSubmitDefault} className={styles.main}>
        <Field title={i18n.t('input')}>
          <Input
            {...form.register('input', requiredRule())}
            errorText={form.formState.errors.input?.message}
          />
        </Field>
        <Field title={i18n.t('dropdown')}>
          <HookFormDropDownInput
            options={personOption}
            name={'dropDown'}
            control={form.control}
          />
        </Field>
        <Field title={i18n.t('multi_select_dropdown')}>
          <HookFormMultiSelectDropDownInput
            options={options}
            name={'multiSelectDropDown'}
            control={form.control}
          />
        </Field>

        <Field title={i18n.t('date')}>
          <HookFormDatePicker name={'date'} control={form.control} />
        </Field>
        <Field title={i18n.t('time')}>
          <HookFormTimePicker
            name={'timeInMilliseconds'}
            control={form.control}
          />
        </Field>

        <div className={styles.buttons}>
          <Button
            className={styles.button}
            type={'button'}
            title="Save"
            color={ButtonColor.Primary}
          ></Button>

          <Button
            className={styles.button}
            type={'button'}
            title="Save"
            color={ButtonColor.Primary}
            disabled
          ></Button>

          <Button
            className={styles.button}
            type={'button'}
            title="Cancel"
            color={ButtonColor.Secondary}
          ></Button>

          <Button
            className={styles.button}
            type={'button'}
            title="Cancel"
            color={ButtonColor.Secondary}
            disabled
          ></Button>

          <Button
            className={styles.button}
            type={'button'}
            title="Delete"
            color={ButtonColor.DestroyPrimary}
          ></Button>

          <Button
            className={styles.button}
            type={'button'}
            title="Delete"
            color={ButtonColor.DestroyPrimary}
            disabled
          ></Button>

          <Button
            className={styles.button}
            type={'button'}
            title="Update"
            color={ButtonColor.DestroySecondary}
          ></Button>

          <Button
            className={styles.button}
            type={'button'}
            title="Update"
            color={ButtonColor.DestroySecondary}
            disabled
          ></Button>

          <p></p>
          <FabButton />

          <TextButton
            color={TextButtonColor.Primary}
            title="Log out"
            icon={<LogoutIcon />}
          />

          <TextButton
            color={TextButtonColor.Primary}
            title="Log out"
            icon={<LogoutIcon />}
            disabled
          />

          <TextButton
            color={TextButtonColor.Destroy}
            title="Delete"
            icon={<DeleteIcon />}
          />

          <TextButton
            color={TextButtonColor.Destroy}
            title="Delete"
            icon={<DeleteIcon />}
            iconClassName="icon"
            disabled
          />
        </div>

        <ProjectCard
          project={{
            id: 1,
            name: 'patientApp',
            iconCode: '23FA',
            currentRevision: '1',
            teamMembers: [],
            isPrivate: false,
            currentUserPermissions: null,
          }}
        />
      </form>
      <TextButton
        color={TextButtonColor.Primary}
        onClick={async () => {
          const result = await modals.showAlert({
            text: 'zxc',
            title: 'qwe',
          });
          alert(result);
        }}
        title={'Show alert'}
      ></TextButton>
      <TextButton
        color={TextButtonColor.Primary}
        onClick={async () => {
          const result = await modals.showConfirm({
            text: 'zxc',
            title: 'qwe',
          });
          alert(result);
        }}
        title={'Show confirm'}
      ></TextButton>
      <TextButton
        color={TextButtonColor.Primary}
        onClick={async () => {
          const result = await modals.showPrompt({
            text: 'zxc',
            title: 'qwe',
            defaultValue: '',
            fieldName: 'Project Name',
          });
          alert(result);
        }}
        title={'Show prompt'}
      ></TextButton>
    </div>
  );
};
